import React, { useState } from 'react';

import { Auth } from 'aws-amplify';
import CloseButton from '../../Styled/CloseButton';
import { Modal } from 'react-bootstrap';
import Step1 from './Step1';
import Step2 from './Step2';
import { deleteUser } from '../../../api/TrustPower';
import modalPropTypes from '../../../propTypes/modalPropTypes';

const DeleteAccountModal = ({ show, onHide, currentUser, setDeleteError }) => {
  const [step, setStep] = useState(1);
  const [isDeleting, setIsDeleting] = useState(undefined);

  // eslint-disable-next-line no-unused-vars
  const [reason, setReason] = useState({
    reason: '',
    reasonDetail: '',
  });

  const onStep1Next = values => {
    setReason(values);
    setStep(2);
  };

  const onSubmit = async () => {
    try {
      // setDeleteError(undefined);
      setIsDeleting(true);
      let reasonStr = reason.reason;
      if (!!reason.reasonDetail) {
        reasonStr += `: ${reason.reasonDetail}`;
      }
      return await deleteUser(reasonStr, false).then(
        async () =>
          await Auth.signOut().then(() => {
            localStorage.clear();
            window.location.href = '/account-deleted';
          }),
      );
    } catch (error) {
      let errorMessage = `${error.message}`;
      if (!!error?.status) {
        errorMessage = `${errorMessage} (${error.status})`;
      }
      setDeleteError(errorMessage);
    }
  };

  const handleOnHide = () => {
    setStep(1);
    setReason({
      reason: '',
      reasonDetail: '',
    });
    onHide();
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}>
      <Modal.Header>
        <CloseButton onClick={onHide} variant={'bordered'} />
      </Modal.Header>
      <Modal.Body className="pt-0 pb-4">
        {step === 1 && <Step1 onNext={onStep1Next} onHide={handleOnHide} />}
        {step === 2 && (
          <Step2
            onNext={onSubmit}
            onHide={handleOnHide}
            currentUser={currentUser}
            isDeleting={isDeleting}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

DeleteAccountModal.propTypes = {
  ...modalPropTypes,
};

export default DeleteAccountModal;
